<template>
  <div class="header">
    <div class="banner_box">
      <div class="con">
        <router-link to="/" class="logo"
          ><img src="../../src/img/headerLogo.png" class="logoImg" alt=""
        /></router-link>
        <ul class="list">
          <el-menu
            :default-active="activeIndex2"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="#fff"
            text-color="#000"
            active-text-color="#247ffDFF"
          >
            <el-menu-item index="1"
              ><router-link to="/" active-class="active" exact
                >首页</router-link
              ></el-menu-item
            >
            <el-menu-item index="2"
              ><router-link to="/about">了解我们</router-link></el-menu-item
            >
            <el-menu-item index="4"
              ><a @click="toguid('index', 'solution_Center')"
                >解决方案</a
              ></el-menu-item
            >
            <el-menu-item index="3"
              ><a @click="toguid('index', 'product_Center')"
                >产品中心</a
              ></el-menu-item
            >
            <el-menu-item index="5"
              ><a href="https://iot.dayufeng.cn/" target="_blank"
                >智慧云平台</a
              ></el-menu-item
            >
            <el-menu-item index="7"
              ><a @click="toguid('index', 'caseShow')"
                >案例展示</a
              ></el-menu-item
            >
            <el-menu-item index="6"
              ><a @click="toguid('index', 'contact_Us')"
                >联系我们</a
              ></el-menu-item
            >
          </el-menu>
        </ul>
      </div>
    </div>
    <div class="banner-box">
      <swiper class="wow animated fadeInUp d1"></swiper>
    </div>
  </div>
</template>
<script>
import swiper from "./swiper";
import Bus from "../utils/bus";
export default {
  components: { swiper },
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    toguid(path, id) {
      var path = path;
      var Id = id;
      localStorage.setItem("toId", Id);
      let curPath = this.$route.path;
      console.log(curPath);
      if (curPath == "/") {
        // this.$router.push({
        //   path: '/?#' + Id,
        // });
        // this.$refs.Id.scrollIntoView();
        Bus.$emit("navId", Id);
      } else {
        this.$router.push({
          name: path,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.banner_box {
  display: flex;
  height: auto;
  background-color: #ffffff;
}

.banner-box {
  width: 100%;
  height: auto;
  background-color: #fff;
}

.logo {
  float: left;

  // margin-top: 20px;
  img {
    width: auto;
    margin-top: 19px;
    height: auto;
  }
}

.list {
  width: auto;
  line-height: 84px;
  font-size: 18px;
  color: #fff;
  float: right;

  li {
    height: 84px;
    line-height: 84px;
    float: left;
  }
}

.logo_txt {
  float: left;
  text-align: left;
  color: #fff;
  // margin-top: 30px;
  margin-left: 30px;

  .tit {
    font-size: 24px;
    letter-spacing: 3px;
    // margin-bottom: 3px;
  }

  .txt {
    font-size: 10px;
  }
}
</style>
<style lang="less">
.el-menu {
  float: right !important;
  border: none !important;
}

.el-menu-item {
  // padding: 0px 30px !important;
  position: relative;
  cursor: auto;
  border: none !important;

  span {
    width: auto;
  }
}

.el-menu.el-menu--horizontal {
  border-bottom: 0px !important;
  // margin-top: 25px !important;
}

.el-menu-item {
  height: 84px;
  line-height: 84px;
  font-size: 18px !important;
  border: none !important;
  cursor: pointer;
  background: none !important;
}

.el-menu--horizontal > .el-menu-item a {
  display: block;
  background: none !important;
}

.el-submenu__title {
  font-size: 18px !important;
  padding-left: 30px !important;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 0px !important;
  background: none !important;
}

.el-icon-arrow-down:before {
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/banner.vue